import config from "../config";
import {getAuth} from "firebase/auth"
import { initializeApp } from "firebase/app";

// Initialize Firebase 

export const auth = getAuth(initializeApp(config.firebaseConfig));